import {Avatar, Box, useMediaQuery, useTheme} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import i18nNamespaces from '../../../../const/i18nNamespaces';
import {
    Appointment,
    AppointmentGroupEnum,
    AppointmentStateEnum,
} from '../../../../types/appointments';
import useStyles from './MedicCardStyles';
import {AppointmentPaymentLabel, AppointmentStateLabel} from '../../../index';
import {HD_READY_DESKTOP_BREAKPOINT} from '../../../../const/sizes';
import {displayUnpaidLabel} from '../../../../utils/appointment';
import { getLanguage, getTranslation } from '../../../../utils/translation';
import i18n from '../../../../i18n/config';
import AppointmentDateTimeBox from '../AppointmentDateTimeBox/AppointmentDateTimeBox';

interface Props {
    appointment: Appointment;
}

const MedicCard = ({appointment}: Props) => {
    const patientData = appointment.child !== null ? appointment.child : appointment.patient;
    const appointmentState = appointment?.state?.state;
    const isInTheFuture = appointmentState === AppointmentStateEnum.Planned;
    const isNow = appointmentState === AppointmentStateEnum.InProgress;
    const currentLanguage = getLanguage(i18n?.language);
    const isPrescriptionAppointment = appointment.appointmentGroup === AppointmentGroupEnum.PrescriptionAppointment;
    
    const classes = useStyles({ isNow, isInTheFuture });
    const startDateTime = appointment?.startDate;
    const {t} = useTranslation(i18nNamespaces.APPOINTMENT);

    const renderAppointmentStatuses = () => {
        return (
            <Box>
                <AppointmentStateLabel
                    style={{marginRight: 5}}
                    state={appointment?.state?.state}
                />
                {displayUnpaidLabel(appointment.paymentStatus) && (
                    <AppointmentPaymentLabel
                        paymentStatus={appointment.paymentStatus}
                    />
                )}
            </Box>
        );
    };

    return (
        <Box className={classes.container}>
            {!isPrescriptionAppointment && (
                <AppointmentDateTimeBox 
                    isNow={isNow} 
                    isInTheFuture={isInTheFuture} 
                    startDateTime={startDateTime} 
                />
            )}
            <Box className={classes.appointmentInfoWrapper}>
                <Box>
                    <Avatar
                        alt={appointment.medic.surname}
                        src={appointment.medic.photoUrl}
                        className={classes.medicPhoto}
                    />
                </Box>
                <Box className={classes.appointmentDetailsAndStatus}>
                    <Box className={classes.appointmentDetails}>
                        <div style={{fontWeight: 'bold', marginBottom: 4}}>
                            {appointment.medic.title}{' '}
                            {appointment.medic.firstName}{' '}
                            {appointment.medic.surname}
                        </div>
                        <div>{getTranslation(appointment.medicalService.name, appointment.medicalService.translations, currentLanguage, "name")}</div>
                        <div>{t('patient')}: {patientData.firstName} {patientData.surname}</div>
                    </Box>
                    <Box className={classes.appointmentStatus}>{renderAppointmentStatuses()}</Box>
                </Box>
            </Box>
        </Box>
    );
};

export default MedicCard;
